module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "job-summary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s7"
  }, [_vm._v("Restricted faces:")]), _vm._v(" "), (_vm.config.RestrictedFaces.length > 0) ? _c('div', {
    staticClass: "col s5"
  }, [_vm._v("Has restricted faces")]) : _c('div', {
    staticClass: "col s5"
  }, [_vm._v("No restrictions")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s7"
  }, [_vm._v("Orientation constraints for optimization, (x, y ,z):")]), _vm._v(" "), (_vm.config.AngleRestriction.length > 0) ? _c('div', {
    staticClass: "col s5"
  }, [_vm._v("\n            " + _vm._s(_vm.config.AngleRestriction[0]) + ", " + _vm._s(_vm.config.AngleRestriction[1]) + ", " + _vm._s(_vm.config.AngleRestriction[2]) + "\n        ")]) : _c('div', {
    staticClass: "col s5"
  }, [_vm._v("No restrictions")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s7"
  }, [_vm._v("Powder thickness:")]), _vm._v(" "), _c('div', {
    staticClass: "col s5"
  }, [_vm._v(_vm._s(_vm.config.layerThickness[0]) + " µm")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s7"
  }, [_vm._v("Top support tooth width:")]), _vm._v(" "), _c('div', {
    staticClass: "col s5"
  }, [_vm._v(_vm._s(_vm.config.Wt[0]) + " mm")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s7"
  }, [_vm._v("Bottom support tooth width:")]), _vm._v(" "), _c('div', {
    staticClass: "col s5"
  }, [_vm._v(_vm._s(_vm.config.Wb[0]) + " mm")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s7"
  }, [_vm._v("Support density:")]), _vm._v(" "), _c('div', {
    staticClass: "col s5"
  }, [_vm._v(_vm._s(parseInt(_vm.config.fraction_avg[0] * 100)) + "%")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s7"
  }, [_vm._v("Printer:")]), _vm._v(" "), _c('div', {
    staticClass: "col s5"
  }, [_vm._v(_vm._s(_vm.config.printer))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s7"
  }, [_vm._v("Material:")]), _vm._v(" "), _c('div', {
    staticClass: "col s5"
  }, [_vm._v(_vm._s(_vm.config.material_name))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s7"
  }, [_vm._v("STL Unit of Measure:")]), _vm._v(" "), _c('div', {
    staticClass: "col s5"
  }, [_vm._v(_vm._s(_vm.config.unit))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s7"
  }, [_vm._v("Element Size:")]), _vm._v(" "), _c('div', {
    staticClass: "col s5"
  }, [_vm._v(_vm._s(_vm.config.elementsize[0] * 1000) + " mm")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s7"
  }, [_vm._v("Z-offset (distance from build plate):")]), _vm._v(" "), _c('div', {
    staticClass: "col s5"
  }, [_vm._v(_vm._s(_vm.config.hsub[0]) + " mm")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s7 input-field-label"
  }, [_vm._v("Job Description:")]), _vm._v(" "), _c('div', {
    staticClass: "col s5 input-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.jobDescriptionData),
      expression: "jobDescriptionData"
    }],
    attrs: {
      "id": "jobDescription",
      "type": "text"
    },
    domProps: {
      "value": (_vm.jobDescriptionData)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.jobDescriptionData = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12 center-align"
  }, [_c('button', {
    staticClass: "a3d btn",
    on: {
      "click": function($event) {
        return _vm.submitData()
      }
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('button', {
    staticClass: "a3d btn inv",
    on: {
      "click": function($event) {
        return _vm.hideSummary()
      }
    }
  }, [_vm._v("Cancel")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12 center-align"
  }, [_c('h4', [_vm._v("Job summary")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3e32201d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e32201d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/JobSummary.vue
// module id = 481
// module chunks = 1